import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { whatsappHref, whatsappMessageForPath } from "@/config/site";
import { trackEvent, EVENTS } from "@/lib/analytics";

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  const href = whatsappHref(whatsappMessageForPath(pathname));
  if (!href) return null; // Hidden until a valid WhatsApp number is configured.

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent(EVENTS.WHATSAPP_CLICKED, { path: pathname })}
      className="group fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-4 text-white shadow-float-lg transition-transform duration-200 hover:scale-105 sm:bottom-8 sm:right-8"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 -z-10 rounded-full bg-[#25D366] opacity-60 animate-pulse-ring" />
      <MessageCircle className="h-6 w-6" />
      <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[140px] sm:inline">
        Chat with us
      </span>
    </a>
  );
}
